  <template>
  <div>
    <template v-if="canConfigurePayments">
      <div class="a-tab__title-block admin__a-tab">
        <h3>{{$t('form.lot.configure-specification')}}</h3>
      </div>

      <specification-config :lot="lot"></specification-config>

      <auto-fill-dates :lot="lot"
                       :lot-rules="lot.schedule.deliveryTypes"
                       :date-label="$t('form.lot.start-date-of-period-for-delivery')"
                       :parts-label="$t('form.lot.parts-for-delivery-dates')"
                       :hint="$t('form.lot.fill-dates-in-delivery-dates-sections')"
                       @apply="onAutoFillDeliveryRulesClick">
      </auto-fill-dates>

      <div class="a-container-form admin-buy__block" >
        <div class="a-label a-label--w-340"></div>
        <div class="a-width-100-percent border-bottom"></div>
      </div>

      <auto-fill-dates :lot="lot"
                       :lot-rules="lot.schedule.paymentTypes"
                       :parts-label="$t('form.lot.parts-for-payment-dates')"
                       :hint="$t('form.lot.fill-dates-in-delivery-bid-template-section')"
                       @apply="onAutoFillPaymentTypesClick">
      </auto-fill-dates>
    </template>

    <list-of-items :lot="lot"></list-of-items>

    <total :lot="lot"></total>

    <template v-if="canConfigurePayments">
      <delivery-schedule :lot="lot"></delivery-schedule>

      <payments-and-parts :lot="lot"></payments-and-parts>
    </template>

    <instructions :lot="lot"></instructions>

    <div class="admin-buy__block-gui-btn a-flex-start">
      <button class="gui-btn gui-btn--red gui-btn--w-207" type="button" :disabled="saveButtonDisabled" v-if="lot.permissions.CAN_MANUALLY_SAVE_LOT" @click="saveChanges">{{$t('buttons.save-changes-in-lot')}}</button>
    </div>
  </div>
</template>

<script>
  import SpecificationConfig from "./blocks/SpecificationConfig";
  import AutoFillDates from "./blocks/AutoFillDates";
  import DeliverySchedule from "./blocks/DeliverySchedule";
  import ListOfItems from "./blocks/ListOfItems";
  import Total from "./blocks/Total";
  import PaymentsAndParts from "./blocks/PaymentsAndParts";
  import CommonMixins from './mixins/common'
  import PermissionsMixins from './mixins/permissions'
  import Instructions from "./blocks/Instructions";

  export default {
    components: {
      Instructions,
      ListOfItems,
      DeliverySchedule,
      SpecificationConfig,
      AutoFillDates,
      Total,
      PaymentsAndParts
    },

    props: {
      lot: Object
    },

    mixins: [
      CommonMixins,
      PermissionsMixins
    ],

    watch: {
      lot: {
        deep: true,
        handler: function(value, old) {
          console.info('Specification: detected lot object is changed lot=', value, ', old=', old);
        }
      }
    },

    computed: {
      canConfigurePayments() {
        return (this.lot.methods.actual.valid && !this.lot.methods.actual.REDUCTION) || !this.lot.methods.planned.REDUCTION;
      }
    },

    methods: {
      async onAutoFillDeliveryRulesClick(rules) {
        const lot = _.cloneDeep(this.lot);
        lot.applyRules({
          deliveryTypes: rules
        });

        await this.checkForm(lot);
      },

      async onAutoFillPaymentTypesClick(rules) {
        const lot = _.cloneDeep(this.lot);
        lot.applyRules({
          paymentTypes: rules
        });

        await this.checkForm(lot);
      }
    }
  }
</script>

<style scoped>
</style>
